import { SVGProps } from 'react';

const SvgEllipsis = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 3" {...props}>
        <path d="M9 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm-4.5 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM0 1.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z" />
    </svg>
);
export default SvgEllipsis;
